import {_getColumns, _grid} from './resource-entry-grid';
import {_dataSource, _getModel, _parse} from './resource-entry-data';

const defaultOptions = {
  name         : 'ResourceEntry',
  startDate    : kendo.date.firstDayOfMonth(kendo.date.today()),
  period       : 'month',
  duration     : undefined, // undefined defaults to 25 - {startDate month}
  readonly     : false,
  collapsible  : true,
  dataSource   : {},
  grid         : {
    noRecords: {
      template: 'No resources of this type found!'
    }
  },
  staticColumns: [],
  columnWidth  : 150,
  input: {
    type: 'currency'
  },
  jsonField    : 'Values',
  remaining    : {
    field: 'Remaining'
  },
  dataBound    : $.noop
};

const events = {
  dataBinding: 'dataBinding',
  dataBound: 'dataBound',
  change: 'change',
  refresh: 'refresh'
};

const eventList = [
  events.dataBinding,
  events.dataBound,
  events.change,
  events.refresh
];

const init = function(element, options) {
  const me = this;
  const $element = $(element);
  let $collapsibleContent;
  const name = $element.attr('id') ?? $element.attr('name') ?? options.name;
  $element.addClass('k-resource-entry');
  const gridElement = $(`<div data-grid-for="${name}"></div>`);
  if(options.collapsible){
    const isAlt = $('.k-resource-entry').length % 2 === 0;
    const $collapsible = $(`<div class="topic collapsible-topic scrollpoint--menu-aside collapsible__toggle--aside collapsible--remote" data-collapsible-for="${name}" id="${name}Collapsible"></div>`)
    .append(`<h2 class="collapsible-topic__toggle topic__title">${options.title}</h2>`);
    if(isAlt) $collapsible.addClass('topic--alt');
    $collapsibleContent = $(`<div class="collapsible-topic__content collapsible--remote"></div>`);
    $collapsible.append($collapsibleContent);
    $collapsibleContent.append(gridElement);
    $element.append($collapsible);
    $collapsible.click(me._loadGrid.bind(me));
  } else $element.append(gridElement);
  kendo.ui.Widget.fn.init.call(me, element, options);
  if(typeof me.options.startDate === 'string') me.options.startDate = new Date(me.options.startDate);
  if(!me.options.duration) me.options.duration = (24 - me.options.startDate.getMonth());
  me.wrapper = me.element;
  me._id = name;
  if(typeof me.options.readonly === 'function') me.readonly = me.options.readonly();
  else  me.readonly = me.options.readonly;
  me.toggleReadonly = me._toggleReadonly;
  me.fieldInfo = me._getFieldInfo();
  me.dataSource = me._dataSource();
  me.grid = me._grid();
  if(!options.collapsible) me._loadGrid();
};

const _loadGrid = function(e) {
  const me = this;
  me.dataSource.fetch()
    .then(() => me.grid.refresh());
};

const _getFieldInfo = function() {
  const me = this;
  const {duration, startDate, period, remaining} = me.options;
  let f = [];
  if(period === 'month') {
    for (let i = 0; i < duration; i++) {
      const colDate = new Date(startDate);
      colDate.setMonth(startDate.getMonth() + i);
      f.push({
        field: kendo.toString(colDate, 'MMMyy'),
        title: kendo.toString(colDate, 'MMM yy')
      });
    }
  }
  if(remaining) {
    f.push({
      field: remaining.field,
      title: 'Remaining'
    });
  }
  return f;
};

const _toggleReadonly = function(state) {
  const me = this;
  if(state === undefined) me.readonly = !me.readonly;
  else me.readonly = state; // after updating state, saveRow if changes
  if(me.dataSource.hasChanges()) me.grid.saveRow();
};

export const ResourceEntry = window.kendo.ui.Widget.extend({
  init,
  options: defaultOptions,
  _dataSource,
  _grid,
  _loadGrid,
  _getFieldInfo,
  _getColumns,
  _getModel,
  _parse,
  _toggleReadonly
});